import { InputPaymentContainer } from "./style";

export function InputPayment ({ width, value, onClick, label, info, errorCartNumber }) {
  return (
    <InputPaymentContainer width={width}>
      <div>
        <p>{label}</p>
        <input
          type="text"
          value={value}
          onClick={onClick}
        />
        <span>
          {info}
        </span>
      </div>
      <span className="errorCart">
        {errorCartNumber}
      </span>
    </InputPaymentContainer>
  )
}